import { render, staticRenderFns } from "./PMCompareWrapper.vue?vue&type=template&id=c54f1964&scoped=true&"
import script from "./PMCompareWrapper.vue?vue&type=script&lang=ts&"
export * from "./PMCompareWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PMCompareWrapper.vue?vue&type=style&index=0&id=c54f1964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54f1964",
  null
  
)

export default component.exports